import { loadingIcon } from "../util/mustache_templates";
import mustache from 'mustache';

export const send_genieTrip_search = async() => {
    let query:string | null;
    let queryEl: HTMLElement | null = document.getElementById('genieTrip_search_query');
    let response:string;
    let success:boolean = false;
    let errMsg:string;

    if (queryEl instanceof HTMLInputElement) {
        query = queryEl.value
    };

    $("#agTrip-catalog-body").html(mustache.render(loadingIcon,{}));


    await $.ajax({
        type:"post",
        url:"/search_genieTrip",
        contentType: "application/json",
        data: JSON.stringify({query:query}),
        dataType: "html",
        success: function(data) { 
            success = true;
            $("#agTrip-catalog-body").html(data);
            $("#genieTrip_search_query").val(query);
            window.scrollTo({top: $("#agTrip-catalog-body").offset().top - 80});
        },
        error: (xhr,errStr,exc) => {errMsg=errStr;}

    });

    //TODO: not sure I still need this, but keeping it in case we change how this functionality works
    return new Promise<void>((resolve,reject) => {
        if (success) resolve();
        else reject (Error(errMsg));
    });
};